import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { find as _find } from 'lodash';
import withRouter from 'js/withRouter';
import { legacyInjectIntl } from 'js/wrapper/injectIntl';
import FormAutocomplete from '../../../components/forms/FormAutocomplete';
const DropdownElementFTs = (props) => {
    var _a, _b;
    const { id, name, attributes, params, updateParam, appIntl } = props;
    const messages = (_b = (_a = appIntl === null || appIntl === void 0 ? void 0 : appIntl.messages) === null || _a === void 0 ? void 0 : _a.messages) !== null && _b !== void 0 ? _b : {};
    const Tag = name;
    const [showDropdown, setShowDropdown] = useState(false);
    const [text, setText] = useState('Please choose a text');
    // componentDidMount
    useEffect(() => {
        setText(messages.pls_choose_text);
        getText();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const setTextValue = useCallback((name, value) => {
        const param = value + '#aaa#';
        const errors = [{ overflow: false, default_image: false }];
        setText(value);
        setShowDropdown(false);
        if (updateParam) {
            updateParam(id, attributes['data-name'], param, errors);
        }
    }, [id, attributes, updateParam]);
    const getText = useCallback(() => {
        const param = _find(params, ['name', attributes['data-name']]);
        if (param) {
            const _text = param.value.split('#aaa#');
            setText(_text === null || _text === void 0 ? void 0 : _text[0]);
        }
        else {
            const dropdownFields = attributes === null || attributes === void 0 ? void 0 : attributes['data-dropdown-options'];
            if (dropdownFields !== undefined) {
                const options = dropdownFields.split(',');
                setText(options === null || options === void 0 ? void 0 : options[0]); // callback i. o.
                setTextValue('setInitialCustomText', options === null || options === void 0 ? void 0 : options[0]); // initial
            }
            else {
                setTextValue('setInitialDefaultText', text); // fallback
            }
        }
    }, [params, attributes, text, setTextValue]);
    const dropdownFields = attributes === null || attributes === void 0 ? void 0 : attributes['data-dropdown-options'];
    const options = dropdownFields ? dropdownFields.split(',') : [];
    return (_jsxs(Tag, Object.assign({}, attributes, { "data-tooltip-content": "", "data-tooltip-id": "top", children: [_jsx("p", { className: "text-default", onClick: () => setShowDropdown(true), children: text }), showDropdown && (_jsx(FormAutocomplete, { onChange: (name, value) => setTextValue(name, value), value: text, label: "", name: "editorDD", options: options.map((option) => ({
                    label: option,
                    value: option,
                })), onBlur: () => setShowDropdown(false) }))] })));
};
// Redux
const mapStateToProps = (state) => ({
    appIntl: state.intl,
});
export default withRouter(connect(mapStateToProps)(legacyInjectIntl(DropdownElementFTs)));
